import React, { useState } from "react";
import "./Accordion.css";
import arrowDown from "./icons/down-arrow.svg";

const Accordion = ({ items }) => {
  const [activeIndex, setActiveIndex] = useState(null);

  const onTitleClick = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <div className="ui styled accordion">
      {items.map((item, index) => {
        const isActive = index === activeIndex;

        return (
          <div key={index} className="accordion-item">
            <button className={`title ${isActive ? "active" : ""}`} 
              aria-expanded={isActive}
              aria-controls={`accordion-content-${index}`}
              onClick={() => onTitleClick(index)}>
              {item.title}
              <span className={`icon ${isActive ? "rotate" : ""}`}>
                <img src={arrowDown} alt="ikon pil ner" aria-hidden="true" />
              </span>
            </button>
            <div id={`accordion-content-${index}`}
              className={`content ${isActive ? "active" : ""}`}
              hidden={!isActive}>
              <p>{item.content}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Accordion;
